import { useEffect, useState } from 'react';
import useStateRef from "react-usestateref";
import Page from 'src/components/Page';
import { useMovementsList } from './api/fetchScripts';
import './styles/index.css';

import { useStyles } from './styles/style';

import { TableBody } from './components/tableBody';
import { TableHeader } from './components/tableHeader';

import { useDebounce } from 'use-debounce';
import { Pagination } from './components/pagination';
import { Search } from './components/search';
import { formatNumber } from './functions/general';

const Movements = (props) => {
  const classes = useStyles();

  const [pageDetail, setPageDetail, pageDetailRef] = useStateRef({
    Limit: 25,
    Page: 1,
    SortBy: 'No',
    SortOrder: 'desc',
  });

  const [searchText, setSearchText, searchTextRef] = useStateRef('');
  const [debounceSearchText] = useDebounce(searchText, 1000);

  const [sortData, setSortData] = useState(defaultSortData)
  const [selectedSort, setSelectedSort] = useState("No")

  const headerData = props.selectedTab === "Acknowledgements" ? headerDataAck : headerDataDefault;
  
  const [selectedProduct, setSelectedProduct] = useState(null);

  const movementsQuery = useMovementsList({
    pageDetail: { ...pageDetail, Status: props.selectedTab },
    searchText: debounceSearchText,
  });

  useEffect(() => {
    setPageDetail({ ...pageDetailRef.current, Page: 1 })
  }, [props.selectedTab])

  const handleChangeSearch = async (e) => {
      setSearchText(e.target.value);
  }

  const searchData = (e) => {
    setPageDetail({ ...pageDetailRef.current, Page: 1 })
  }

  const clearSearch = () => {
    setSearchText("");
    setPageDetail({ ...pageDetailRef.current, Page: 1 })
  }

  const clickSortData = async (value, type) => {
    if (["No", "Posting_Date"].includes(value)) {
      const new_sort_data = { ...defaultSortData };
      const isDifferentSort = selectedSort !== value;
      const new_type = isDifferentSort ? "asc" : type === "asc" ? "desc" : "asc";
      const sortKey = sortData[value]?.key || value;

      new_sort_data[value].sort = new_type;
      setSortData(new_sort_data);
      setSelectedSort(value);
      setPageDetail({ ...pageDetailRef.current, Page: 1, SortBy: sortKey, SortOrder: new_type });
    }
  }

  const expandProduct = (product_id) => {
    if (selectedProduct === product_id) {
      setSelectedProduct(null);
    } else {
      setSelectedProduct(product_id);
    }
  }

  const handleChangeMenu = async (event) => {
    setPageDetail({ ...pageDetailRef.current, Limit: event.target.value, Page: 1 });
  };

  const onClickNavigation = async (step) => {
    var pageNumber = pageDetailRef.current.Page + step;
    setPageDetail({
      ...pageDetailRef.current, Page: pageNumber
    })
  }

  return (
    <Page title="Movements" className="content-container">
      <div className="content-container-wrapper">
        <div className="orders-content-container">
          <div className="orders-content-wrapper">
            <div className="orders-content-filter">
              <Search
                searchData={searchData}
                searchText={searchTextRef.current}
                handleChangeSearch={handleChangeSearch}
                classes={classes}
                clearSearch={clearSearch}
              />
              <div className="orders-content-filter-right order-page">
                {movementsQuery.data?.transferOrder.length > 0 ? (
                  <Pagination
                    handleChangeMenu={handleChangeMenu}
                    pageDetail={movementsQuery.data?.pagination || {}}
                    onClickNavigation={onClickNavigation}
                  />
                ) : (
                  <div style={{ minHeight: '55px' }}></div>
                )}
              </div>
            </div>
            <div className="orders-content-table-container">
              <div className="orders-content-table">
                <TableHeader
                  headerData={headerData}
                  clickSortData={clickSortData}
                  selectedSort={selectedSort}
                  sortData={sortData}
                  pageDetail={pageDetailRef.current}
                />
                <TableBody
                  ordersData={movementsQuery.data?.transferOrder || []}
                  selectedProduct={selectedProduct}
                  headerData={headerData}
                  expandProduct={expandProduct}
                  formatNumber={formatNumber}
                  isLoading={movementsQuery.isFetching}
                  selectedTab={props.selectedTab}
                />
              </div>
            </div>
          </div>
        </div>

        <div style={{ minHeight: '40px' }}></div>
      </div>
    </Page>
  );
}

const defaultSortData = {
  No: { sort: 'desc', key: 'No' },
  Posting_Date: { sort: 'desc', key: 'Posting_Date' },
};

const headerDataDefault = [
  { id: 'No', name: 'Order ID', width_table: 12 },
  { id: 'Posting_Date', name: 'Order Date', width_table: 12 },
  { id: 'Products', name: 'Products', width_table: 9 },
  { id: 'Units', name: 'Units', width_table: 9 },
  { id: 'Status', name: 'Status', width_table: 12 },
  { id: 'View', name: 'View', width_table: 12 },
  { id: 'Expand', name: 'Expand', width_table: 34 },
];

const headerDataAck = [
  { id: 'No', name: 'Order ID', width_table: 12 },
  { id: 'Posting_Date', name: 'Order Date', width_table: 12 },
  { id: 'Due', name: 'Past Due', width_table: 11 },
  { id: 'Track', name: 'Track', width_table: 11 },
  { id: 'View', name: 'View Order', width_table: 10 },
  { id: 'Status', name: 'Status', width_table: 15 },
  { id: 'Actions', name: 'Actions', width_table: 24 },
  { id: 'Action', name: '', width_table: 5 },
];

export default Movements;